<app-main-layout>
  <section class="flex flex-col gap-3">
    <app-card>
      <app-card-header
        title="Gewichtstagebuch"
        [iconPath]="'assets/icons/barbell.svg'"
        [showLoadingSpinner]="requestState() === RequestStateEnum.PENDING"
      />

      <div class="mb-5">
        <app-button
          text="Messung hinzufügen"
          [fullWidth]="true"
          (clicked)="openCreateUpdateWeightModal()"
        />
      </div>

      <app-paginator
        [intervalType]="paginatorIntervalTypeEnum.MONTH"
        (paginationChange)="onPaginatorChange($event.index, $event.year)"
      />

      <div
        class="border-light-grey"
        [class.border-t]="sortedWeightEntries().length > 0"
      >
        @if (sortedWeightEntries().length > 0) {
          @for (weightItem of sortedWeightEntries(); track weightItem.id) {
            <app-weight-item
              [weightItem]="weightItem"
              (clicked)="openCreateUpdateWeightModal(weightItem.id)"
            />
          }
        } @else {
          <app-no-entries-placeholder />
        }
      </div>
    </app-card>
  </section>
</app-main-layout>
